import config from '@/config'
import axios from 'axios'
import { SnapToRoadResponse } from '@/types//Maps'

class GoogleMapsService {
  async getSnapToRoadsLocations (locations: string[], interpolate?: boolean): Promise<SnapToRoadResponse> {
    interpolate = true
    const response = await axios.get(config.googleMaps.getSnapToRoadsUrl(locations) + (interpolate ? '&interpolate=true' : ''))
    return response.data
  }
}

export default new GoogleMapsService()
